import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { IGetState, TBoardId } from '../../../../../../../../../types/types';
import { webhooksSave } from '../../../../../../../../../rest/effects/webhooks/webhooksSave';

export const onSave = (
    boardId: TBoardId,
    webhook: string,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return fetch(webhook, { method: 'POST', body: 'test' }).then((res) => {
            if (res.status !== 200) throw new Error();

            return dispatch(webhooksSave(boardId, webhook)).then(() => {
                return Promise.resolve(true);
            });
        }).catch((e) => {
            return Promise.resolve(false);
        });
    };
    return action;
};
